<template>
    <b-row>
        <b-col>
            <b-spinner v-if="integrating"></b-spinner>
            <b-row v-else >
                
                
                <template >
                    <b-col cols="12" md="4" v-if="isActive && canDeactivate"><b-button class="ml-2" variant="warning" @click="deactivate()" >{{ $t('deactivate') }}</b-button></b-col>
                    <template v-else>
                        <b-col cols="12" md="4"><protokol-checkout-button v-if="canShowBuy" productType="integration" :reference="integration.id" block>{{ $t('buy') }} {{ price.price }} {{ price.currency }}</protokol-checkout-button></b-col>
                        <b-col cols="12" md="4"><b-button variant="primary" v-if="canShowTrial" class="ml-2" @click="startTrial" block>{{ $t('startTrial') }}</b-button></b-col>
                        <b-col cols="12" md="4" v-if="!isActive && canShowInstall"><b-button class="ml-2" variant="primary" @click="activate()">{{ $t('activate') }}</b-button></b-col>
                    </template>
                    
                </template> 
            </b-row>
        </b-col>
    </b-row>
</template>

<style scoped>
.integration {
    text-align: center;
    cursor: pointer;
}

.integration h4 {
    font-size: 18px;
    margin-top: 10px;
}
</style>

<script>
import Integration from '../../lib/Integration'
import Price from '@/plugins/protokol/lib/Price'

export default {
    name: 'StartTrialFooter',
    props: {
        integration: {
            type: Object
        },
        autoIntegrate: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            integrating: false
        }
    },
    computed: {
        canShowTrial() {
            return !this.$store.getters.isTrialUsed(this.integration.product_id)
        },

        canShowBuy() {
            let subs = this.$store.getters.getSubscriptions || []

            let integrationSub = subs.find(s => {
                return s.product_id == this.integration.product_id && s.is_trial
            })

            return integrationSub === undefined
        },

        canShowInstall() {
            let subs = this.$store.getters.getSubscriptions || []
            let valid = subs.find(s => {
                return s.product_id == this.integration.product_id
            })

            return this.price <= 0 || valid !== undefined
        },

        price() {
            const { billing_address } = this.$store.getters.getUser.settings
            const { country } = billing_address || {}

            const price = new Price(
                country,
                this.$store.getters.getLocale
            )

            return price.getPriceAndCurrency(this.integration.price)
        },

        canDeactivate() {
            const integration = this.$store.getters.getIntegrationByID(this.integration.id)

            return integration.dependencies.length == 1 && integration.dependencies[0] == "platform"
        },

        isActive() {
            return this.$store.getters.isIntegrationActive(this.integration.id)
        }
    },

    methods: {
        installInProgress() {
            this.$store.dispatch("fetchIntegrations", true).then(() => {
                if (this.$store.getters.isIntegrationActive(this.integration.id)) {
                    this.integrating = false

                    this.$emit("activate", this.integration)
                } else {
                    setTimeout(this.installInProgress, 3000)
                }
            })
        },

        async activate() {
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('integrations.activateAreYouSure'));
            if (!confirm) return

            if (this.autoIntegrate) {
                this.integrating = true;

                this.$store.dispatch("activateIntegration", this.integration).then(() => {
                    setTimeout(this.installInProgress, 1000)
                }).catch(err => {
                    this.$debugLog(err)
                    this.$bvModal.msgBoxOk(`${this.$t('failedToInstall')}.`)
                    this.integrating = false
                })

                return;
            }

        },

        async deactivate() {
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('integrations.deactivateAreYouSure'));
            if (!confirm) return

            if (this.autoIntegrate) {
                this.integrating = true;
                
                this.$store.dispatch("deactivateIntegration", this.integration).catch(err => {
                    this.$debugLog(err)

                    if (err.response) {
                        console.log(err.response)
                        if (err.response.status == 409) {
                            this.$bvModal.msgBoxOk(this.$t(err.response.data.message))
                            return
                        }
                    }

                    this.$bvModal.msgBoxOk(`${this.$t('failedToRemove')}.`)
                }).finally(() => {
                    this.integrating = false
                })

                return
            }

            this.$emit("deactivate", this.integration)
        },

        buy() {
            var integration = new Integration(
                this.integration,
                this.$store.getters.getLocale
            )

            const popup = this.$loadingPopup

            this.$transactionApi.post("/checkout/link", {product_type: "integration", reference: this.integration.id, lang: this.$store.getters.getLocale}).then(resp => {
                window.open(resp.data, '_blank')
            }).catch(err => {
                if (err.response) {
                    if (err.response.status == 501) {
                        this.$bvToast.toast(this.$t('checkoutMethodCurrentlyDisabled'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                        return 
                    }
               }

               this.$bvModal.msgBoxOk(this.$t('unexpectedError'))
            }).finally(() => {
                popup.hide()
            }) 
        },

        startTrial() {
            const popup = this.$loadingPopup()
            this.$transactions.startTrial({
                product_type: "integration",
                reference: this.integration.id,
                source: "platform"
            }).then((resp) => {
                this.$bvToast.toast(this.$t('trialIsNowActive'), {
                    variant: 'success',
                    title: this.$t('success')
                })

                resp.data.forEach(d => {
                    this.$store.commit("ADD_TRIAL", d)
                })

                this.$store.dispatch("fetchSubscriptions", true)
            }).catch((err) => {
                this.$debugLog()
                this.$bvToast.toast(this.$t('failedToStartTrial'), {
                    variant: 'danger',
                    title: this.$t('error')
                })
            }).finally(() => {
                popup.hide()
            })
        }
    },

    async mounted() {
        await this.$store.dispatch("fetchSubscriptions", true)
        await this.$store.dispatch("fetchTrials")
    }
}
</script>
